import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import StickyBox from "react-sticky-box";
export function SharedTableHeader(props) {
    const { visibleColumns, adjustedColumns, sortOption, onSortChange, stickyOffset, headerClassName, subHeaderClassName, gridTemplateColumns, hasSubHeader, renderColumnResizeHandle, } = props;
    return (_jsxs(StickyBox, { offsetTop: stickyOffset, style: { zIndex: 40, marginTop: -1 }, children: [_jsx("div", { className: headerClassName, style: { display: "grid", gridTemplateColumns }, children: visibleColumns.map((colId) => {
                    const col = adjustedColumns[colId];
                    if (!col)
                        return null;
                    const resizeHandle = renderColumnResizeHandle?.(colId);
                    return (_jsxs("div", { className: col.className, style: resizeHandle
                            ? { position: "relative" }
                            : undefined, children: [col.renderHeader ? (col.renderHeader({
                                sortOption,
                                onSortChange,
                            })) : (_jsxs(_Fragment, { children: ["Header col ", colId] })), resizeHandle] }, colId));
                }) }), hasSubHeader && (_jsx("div", { className: subHeaderClassName, style: { display: "grid", gridTemplateColumns }, children: visibleColumns.map((colId) => {
                    const col = adjustedColumns[colId];
                    if (!col)
                        return null;
                    return (_jsx("div", { className: col.className, children: col.renderSubHeader ? (col.renderSubHeader()) : (_jsx("div", {})) }, colId));
                }) }))] }));
}
